export default Object.freeze([
    'capacity',
    'loss',
]);
